//Show-Hide Password
document.querySelectorAll(".toggle-password").forEach((toggle) => {
    toggle.addEventListener("click", () => {
        const wrapper = toggle.closest(".input-wrapper");
        const input = wrapper.querySelector(
            'input[type="password"], input[type="text"]'
        );
        const icon = toggle.querySelector("i");

        // Toggle input type
        input.type = input.type === "password" ? "text" : "password";

        // Toggle icon class
        icon.classList.toggle("fa-eye-slash");
        icon.classList.toggle("fa-eye");
    });
});

//Toggle alert
document.addEventListener("DOMContentLoaded", () => {
    const alertBox = document.getElementById("custom_alert");
    if (!alertBox) return; // Stop if alert box not found

    const closeBtn = alertBox.querySelector(".close-btn");
    if (!closeBtn) return; // Stop if close button missing

    closeBtn.addEventListener("click", () => {
        alertBox.style.opacity = "0";
        alertBox.style.visibility = "hidden";
        setTimeout(() => {
            alertBox.style.display = "none";
        }, 300);
    });
});

// Password strength checker
document.addEventListener("DOMContentLoaded", () => {
    const passwordField = document.getElementById("password");
    const submitBtn = document.getElementById("submitBtn");
    const strengthIndicator = document.querySelector(".strength-indicator");
    const passwordHint = document.querySelector(".js-password-hint");
    const minChar = document.querySelector("#min-char-valid .validation-text");
    const upperCase = document.querySelector(
        "#uppercase-valid .validation-text"
    );
    const lowerCase = document.querySelector(
        "#lowercase-valid .validation-text"
    );
    const numbers = document.querySelector("#numbers-valid .validation-text");
    const symbols = document.querySelector("#symbols-valid .validation-text");

    const passwordConfirmField = document.getElementById("password-confirm");
    const matchMessage = document.getElementById("confirm-match-message");

    if (passwordConfirmField && matchMessage) {
        const validateMatch = () => {
            if (
                passwordConfirmField.value &&
                passwordConfirmField.value !== passwordField.value
            ) {
                matchMessage.classList.remove("d-none");
                submitBtn.disabled = true;
            } else {
                matchMessage.classList.add("d-none");
                submitBtn.disabled = false;
            }
        };

        passwordField.addEventListener("input", validateMatch);
        passwordConfirmField.addEventListener("input", validateMatch);
    }

    if (!passwordField) return;

    if (passwordHint) {
        passwordHint.style.display = "none";
    }

    passwordField.addEventListener("input", () => {
        const value = passwordField.value;
        const length = value.length;

        const inputWrapper = passwordField.closest(".input-wrapper");

        if (passwordHint && inputWrapper) {
            if (length > 0 && length < 12) {
                passwordHint.style.display = "block";
                inputWrapper.classList.add("has-error");
            } else {
                passwordHint.style.display = "none";
                if (!inputWrapper.querySelector(".invalid-feedback.d-block")) {
                    inputWrapper.classList.remove("has-error");
                }
            }
        }

        const strengthCharacterWrap = document.getElementById(
            "strength-character-wrap"
        );
        if (strengthCharacterWrap) {
            strengthCharacterWrap.style.display =
                value.length > 0 ? "block" : "none";
        }

        const strengthIndicator = document.querySelector(".strength-indicator");
        if (!strengthIndicator) return;

        if (strengthIndicator) {
            strengthIndicator.style.display =
                value.length > 0 ? "block" : "none";
        }

        const validations = {
            minChar: value.length >= 12,
            upperCase: /[A-Z]/.test(value),
            lowerCase: /[a-z]/.test(value),
            numbers: /\d/.test(value),
            symbols: /[^A-Za-z0-9]/.test(value),
        };

        // Apply classes based on validation
        function updateValidationClass(el, isValid) {
            if (!el) return;
            const newClass = isValid ? "text-green" : "text-danger";
            el.classList.remove("text-danger", "text-green", "text-red");
            el.classList.add(newClass);
            el.setAttribute("class", newClass);
        }

        updateValidationClass(minChar, validations.minChar);
        updateValidationClass(upperCase, validations.upperCase);
        updateValidationClass(lowerCase, validations.lowerCase);
        updateValidationClass(numbers, validations.numbers);
        updateValidationClass(symbols, validations.symbols);

        const passed = Object.values(validations).filter((v) => v).length;
        const strengthLevels = ["very-weak", "weak", "medium", "strong"];
        const index = Math.max(
            0,
            Math.min(strengthLevels.length - 1, passed - 1)
        );
        const strengthClass = strengthLevels[index];

        const capitalized = strengthClass
            ? strengthClass.charAt(0).toUpperCase() + strengthClass.slice(1)
            : "Strength";

        // Update class name here to reflect color/style change
        strengthIndicator.className = `strength-indicator ${strengthClass}`;
        strengthIndicator.querySelector(
            "p"
        ).innerHTML = `<i class="fa-solid fa-triangle-exclamation"></i> ${capitalized}`;

        // Disable submit button unless all passed
        if (submitBtn) {
            submitBtn.disabled = passed < 5;
        }
    });
});

// Create password success modal
document.addEventListener("DOMContentLoaded", function () {
    const page = document.querySelector(".create-password-page");

    if (page?.dataset?.passwordCreated === "true") {
        const confirmModalEl = document.getElementById("confirmModal");
        if (confirmModalEl) {
            const confirmModal = new bootstrap.Modal(confirmModalEl);
            confirmModal.show();
        }
    }
});
